import { DocumentVersionType } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IDocumentVersionListItem {
    id: string;
    version: number;
    contentVersion: number;
    type: DocumentVersionType;
    modifyUser: IModifyUser;
}

export class DocumentVersionListItem implements IDocumentVersionListItem {
    id: string;
    version: number;
    contentVersion: number;
    type: DocumentVersionType;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IDocumentVersionListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.version = obj && obj.version || 0;
        this.contentVersion = obj && obj.contentVersion || 0;
        this.type = obj && obj.type || DocumentVersionType.AutoSave;
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}
